import { Action } from 'redux';
import { MedigapDrugItem, MedigapMedicationsForm } from 'src/app/shared/interfaces/application-retrieval/retrieveApp.interface';

export interface MedigapMedicationsStateStructure {
  medicationForm: MedigapMedicationsForm;
}

export class MedigapMedicationsAction implements Action {
  type: string;
  medication?: MedigapDrugItem;
  medicationForm?: MedigapMedicationsForm;
}

const INITIAL_STATE: MedigapMedicationsStateStructure = {
  medicationForm: {
    isPrescribedMeds: null,
    medications: [{
      medicationName: '',
      medicationDosage: '',
      conditionForMed: '',
      currentlyTaking: ''
    }]
  }
};

export const ADD_MED = 'ADD_MED';
export const REMOVE_MED = 'REMOVE_MED';
const RESET_STATE = 'RESET_STATE_Medications';
const LOAD_MEDICATION_STATE = 'LOAD_MEDICATION_STATE';

export function addMedication(medication: MedigapDrugItem): MedigapMedicationsAction {
  return { type: ADD_MED, medication };
}

export function removeMedication(medication: MedigapDrugItem): MedigapMedicationsAction {
  return { type: REMOVE_MED, medication };
}

export function loadExistingMedicationsIntoState(isPrescribedMeds:string, medications: MedigapDrugItem[]): MedigapMedicationsAction {
  return { 
    type: LOAD_MEDICATION_STATE,
    medicationForm: {
      isPrescribedMeds,
      medications
    } 
  };
}

export function resetMeds(): MedigapMedicationsAction {
  return { type: RESET_STATE};
}

export function MedigapMeds(
  state: MedigapMedicationsStateStructure = INITIAL_STATE,
  action: MedigapMedicationsAction
) {
  const copiedState: MedigapMedicationsStateStructure
    = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {
    case ADD_MED:
      copiedState.medicationForm.medications.push(action.medication);
      return Object.assign({}, state, copiedState);
    case REMOVE_MED:
      copiedState.medicationForm.medications
        = copiedState.medicationForm.medications.filter( med => {
          // All fields are identical
          return (
            med.conditionForMed === action.medication.conditionForMed &&
            med.currentlyTaking === action.medication.currentlyTaking &&
            med.medicationDosage === action.medication.medicationDosage &&
            med.medicationName === action.medication.medicationName
          );
        });
      return Object.assign({}, state, copiedState);
    case LOAD_MEDICATION_STATE:
      copiedState.medicationForm = action.medicationForm;
      return Object.assign({}, state, copiedState); 
    case RESET_STATE:
      return INITIAL_STATE;
    default:
      return state;
  }
}
